const PATTERN_CLASSES = [
  "-pattern-01",
  "-pattern-02",
  "-pattern-03",
  "-pattern-04",
  "-pattern-05",
  "-pattern-06",
];

const INTERVAL_MS = 3000;

const prevPatternByEl = new WeakMap();

const pickRandomDifferent = (previous) => {
  const pool = previous
    ? PATTERN_CLASSES.filter((c) => c !== previous)
    : PATTERN_CLASSES;
  return pool[Math.floor(Math.random() * pool.length)];
};

const applyRandomPatterns = (elements) => {
  elements.forEach((el) => {
    const previous = prevPatternByEl.get(el);
    const next = pickRandomDifferent(previous);
    PATTERN_CLASSES.forEach((c) => el.classList.remove(c));
    el.classList.add(next);
    prevPatternByEl.set(el, next);
  });
};

export const introClipImgPattern = () => {
  const elements = document.querySelectorAll(".js-intro-clip-img");
  if (!elements.length) return;

  const tick = () => applyRandomPatterns(elements);

  tick();
  setInterval(tick, INTERVAL_MS);
};
